import { FC } from 'react';

import { IconProps } from '../types';

export const PaperOkIcon: FC<IconProps> = ({
	size,
	height = 24,
	width = 24,
	color = '#06519E',
}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={size ?? width}
		height={size ?? height}
		viewBox="0 0 24 24"
	>
		<path
			fill={color}
			fillRule="evenodd"
			d="M18 23H4c-.552 0-1-.45-1-1s.448-1 1-1h14c.552 0 1-.45 1-1V9h-5c-.553 0-1-.45-1-1V3H6c-.55 0-1 .45-1 1v4c0 .55-.448 1-1 1s-1-.45-1-1V4c0-1.65 1.346-3 3-3h8.5c.266 0 .52.11.707.29l5.5 5.5c.188.19.293.45.293.71V20c0 1.65-1.346 3-3 3ZM15 3.91 18.086 7H15V3.91Z"
		/>
		<path
			fill={color}
			fillRule="evenodd"
			d="M4.293 17.71c.195.19.451.29.707.29.256 0 .512-.1.707-.29l4-4c.391-.39.391-1.03 0-1.42a1 1 0 0 0-1.414 0L5 15.59l-1.293-1.3a1 1 0 0 0-1.414 0 1.006 1.006 0 0 0 0 1.42l2 2Z"
		/>
	</svg>
);
